var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 12.353547,10.353548 c -0.195259,0.19527 -0.511839,0.19527 -0.707099,0 l -3.6464505,-3.6464405 -3.6464,3.6464405 c -0.1953,0.19527 -0.5119,0.19527 -0.7072,0 -0.1952,-0.19526 -0.1952,-0.5118405 0,-0.7071005 l 4.00005,-4.00005 c 0.19526,-0.1952 0.51184,-0.1952 0.7071,0 l 3.9999995,4.00005 c 0.195271,0.19526 0.195271,0.5118405 0,0.7071005 z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/chevron_up.c3bb28ae.svg";
export { ForwardRef as ReactComponent };